import { render } from "./GroupCardViewColumnizer.vue?vue&type=template&id=2a5bad4e&scoped=true"
import script from "./GroupCardViewColumnizer.vue?vue&type=script&lang=js"
export * from "./GroupCardViewColumnizer.vue?vue&type=script&lang=js"

import "./GroupCardViewColumnizer.vue?vue&type=style&index=0&id=2a5bad4e&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\a\\WebApp\\FAOU.App\\clientapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a5bad4e"]])

export default __exports__